module.exports = __webpack_public_path__ + "static/media/media-de.980e75e7.jpeg";